module.exports = __webpack_public_path__ + "static/media/productos-resumen.8ff24f22.png";